if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
        };

        this.submitEl.addEventListener('click', this.onClick.bind(this));
      }

      get submitEl() {
        return (this._submitEl = this._submitEl || this.querySelector('.product-form__submit'));
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');

        this.init();

        /* CUSTOM: Scroll-to-variants link */
        this.scrollLink = this.querySelector('[data-scroll-to-variants]');
        if (this.scrollLink) {
          this.scrollLink.addEventListener('click', (e) => {
            e.preventDefault();
            const target = document.querySelector('variant-selects');
            if (target) {
              window.scrollTo({
                behavior: 'smooth',
                top: target.getBoundingClientRect().top + window.scrollY - 100,
              });
            }
          });
        }
        /* END CUSTOM */

        this.cartErrorUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, () => {
          this.resetButtonLoading();
          this.scrollToTop(this.productFormActions);
        });

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
          this.resetButtonLoading();
        });
      }

      disconnectedCallback() {
        if (this.cartErrorUnsubscriber) this.cartErrorUnsubscriber();
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      init() {
        if (!this.productFormActions) {
          this.classList.remove(this.classes.isOpen);
          return;
        }

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle(this.classes.isOpen, isAboveViewport);
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
        this.syncWithMainProductForm();
      }

      onClick() {
        this.submitEl.setAttribute('aria-disabled', 'true');
        this.submitEl.classList.add('btn--loading');
      }

      resetButtonLoading() {
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      }

      scrollToTop(target, offset = 200) {
        window.scrollTo({
          behavior: 'smooth',
          top: target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
        });
      }

      /* CUSTOM: Toggle between scroll link and submit button */
      updateButton(disable = true, text, modifyClass = true) {
        const btn = this.submitEl;
        if (!btn) return;

        const btnText = btn.querySelector('span');
        const isNoVariant = !this.currentVariant && text && text !== FoxTheme.variantStrings.soldOut;

        if (isNoVariant) {
          btn.classList.add('hidden');
          if (this.scrollLink) {
            this.scrollLink.classList.remove('hidden');
            if (text) (this.scrollLink.querySelector('span') || this.scrollLink).textContent = text;
          }
        } else {
          if (this.scrollLink) this.scrollLink.classList.add('hidden');
          btn.classList.remove('hidden');
          if (disable) {
            btn.setAttribute('disabled', 'disabled');
            if (text) btnText.textContent = text;
          } else {
            btn.removeAttribute('disabled');
            btnText.textContent = FoxTheme.variantStrings.addToCart;
          }
        }
      }
      /* END CUSTOM */

      updatePrice(variant) {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = variant;

        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        if (!variant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`)
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            variant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      /* CUSTOM: Dynamic variant change handling */
      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;

          const variant = event.data.variant;
          this.currentVariant = variant;

          if (variant) {
            this.updatePrice(variant);
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          } else {
            const optionLabel = this.mainProductInfo?.querySelector('.form__label .font-body-bolder');
            const firstOptionName = optionLabel?.textContent?.replace(':', '').trim() || '';
            this.updateButton(true, FoxTheme.variantStrings.selectVariant.replace('[name]', firstOptionName));
          }
        });
      }
      /* END CUSTOM */
    }
  );
}
